
<nb-layout [nbSpinner]="!!(isLoading() | async)">
  <nb-layout-header fixed *ngIf="!isZSuite && (isLogged() | async)" style="z-index: 1040">
    <app-nav-menu></app-nav-menu>
  </nb-layout-header>

  <nb-sidebar *ngIf="isLogged() | async" tag="left" [fixed]="mobileMenu">
    <app-side-menu></app-side-menu>
  </nb-sidebar>

  <nb-layout-column [hidden]="!!(isLoading() | async)" [ngClass]="{'p-0' : !(isLogged() | async)}">
    <router-outlet></router-outlet>
    <app-preview-banner></app-preview-banner>
  </nb-layout-column>

  <nb-layout-footer fixed *ngIf="isLogged() | async">
    <app-footer></app-footer>
  </nb-layout-footer>
</nb-layout>
